<template>
  <v-dialog v-model="dialog" persistent width="300">
    <common-card>
      <v-card-text class="pa-4">
        <div class="modal-overlay">
          <div class="modal-content">
            <h2 class="modal-title">Folio de redención:</h2>

            <div class="folio-box no-select">
              {{ folio }}
            </div>

            <p class="timer-text">
              Tiempo en pantalla: {{ remainingTime }}s
            </p>
          </div>
        </div>
          <v-card-actions class="justify-center">
            <v-btn  color="red" dark @click="$emit('update:dialog', false)">
              Cerrar
            </v-btn>
          </v-card-actions>
      </v-card-text>
    </common-card>
  </v-dialog>
</template>

<script>
import CommonCard from "./CommonCard.vue";

export default {
  components: {
    CommonCard,
  },
  props: {
    dialog: Boolean,
    folio: {
      type: String,
      required: true,
    },
    autoCloseTime: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
      closeTimerId: null,
      countdownId: null,
      remainingTime: 60
    };
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.startCloseTimer();
        this.startCountdown();
      } else {
        this.clearTimers();
      }
    }
  },
  methods: {
    startCloseTimer() {
      this.clearTimers();
      this.remainingTime = this.autoCloseTime;
      
      this.closeTimerId = setTimeout(() => {
        this.$emit('update:dialog', false);
      }, this.autoCloseTime * 1000);
    },
    
    startCountdown() {
      this.countdownId = setInterval(() => {
        this.remainingTime--;
        if (this.remainingTime <= 0) {
          this.clearTimers();
        }
      }, 1000);
    },
    
    clearTimers() {
      if (this.closeTimerId) {
        clearTimeout(this.closeTimerId);
        this.closeTimerId = null;
      }
      if (this.countdownId) {
        clearInterval(this.countdownId);
        this.countdownId = null;
      }
    }
  },
  beforeUnmount() {
    this.clearTimers();
  }
};
</script>

<style scoped>
.modal-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  padding: 0.5rem;
  border-radius: 1rem;
  width: 250px;
  text-align: center;
}

.modal-title {
  color: #1e3a8a; 
  font-weight: 600;
  font-size: 1.125rem;
  margin-bottom: 1rem;
}

.folio-box {
  border: 1px solid #cbd5e0;
  border-radius: 0.375rem;
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  font-weight: 500;
  color: #000;
  background-color: white;
  margin-bottom: 1rem;
}

.no-select {
  user-select: none; 
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-touch-callout: none; 
  cursor: default;
}

.timer-text {
  color: #dc2626; 
  font-weight: 600;
  font-size: 0.875rem;
}
</style>